export default __webpack_public_path__ + "static/media/handRobot.bdf66aff.png";